import { addCustomCSS } from '@ui5/webcomponents-base/dist/Theming';

export default function () {
    addCustomCSS(
        'ui5-li-suggestion-item',
        '.ui5-li-root { border-top: 1px solid rgb(136, 136, 136); }'
    );
    addCustomCSS(
        'ui5-li',
        '.ui5-li-root { border-top: 1px solid rgb(136, 136, 136); }'
    );
    addCustomCSS(
        'ui5-checkbox',
        '.ui5-checkbox-inner { background-color: #fafafa !important; border: 1px solid #888888 !important; }'
    );
    addCustomCSS(
        'ui5-checkbox',
        '.ui5-checkbox-root:focus::before { content: none; }'
    );
}

window.addUI5CSS = addCustomCSS; //Just for live testing
